import { useSuspenseQuery } from '@tanstack/react-query'

import { GetConfiguracoesPreco } from '@/features/simulador/brasil/http'
import type { TTipoAmortizacaoEnum } from '@/types/simulacao'
import { CINCO_MINUTOS } from '@/utils/constants'
import { produtosKeys } from '@/utils/produtos-query-keys'

export const useSuspenseConfiguracoesDePreco = (
  idExternoProduto: number,
  idExternoBloco: number,
  tipoDeAmortizacao?: TTipoAmortizacaoEnum | null,
) => {
  return useSuspenseQuery({
    queryKey: produtosKeys.configuracaoDePreco(idExternoProduto, idExternoBloco, tipoDeAmortizacao),
    queryFn: () =>
      new GetConfiguracoesPreco().execute(idExternoProduto, idExternoBloco, tipoDeAmortizacao).then(({ data }) => data),
    staleTime: CINCO_MINUTOS,
  })
}
